import {
    FETCH_AGENT_ANALYTICS_DASHBOARD_REQUEST,
    FETCH_AGENT_ANALYTICS_DASHBOARD_SUCCESS,
    FETCH_AGENT_ANALYTICS_DASHBOARD_FAILURE,
    FETCH_AGENT_PROGRAMME_REQUEST,
    FETCH_AGENT_PROGRAMME_SUCCESS,
    FETCH_AGENT_PROGRAMME_FAILURE,
    FETCH_AGENT_CERTIFICATION_REQUEST,
    FETCH_AGENT_CERTIFICATION_SUCCESS,
    FETCH_AGENT_CERTIFICATION_FAILURE,
    FETCH_AGENT_OPERATIONS_REQUEST,
    FETCH_AGENT_OPERATIONS_SUCCESS,
    FETCH_AGENT_OPERATIONS_FAILURE,
    FETCH_TOP_PERFORMING_AGENTS_REQUEST,
    FETCH_TOP_PERFORMING_AGENTS_SUCCESS,
    FETCH_TOP_PERFORMING_AGENTS_FAILURE,
    FETCH_AGENT_PERFORMANCE_REQUEST,
    FETCH_AGENT_PERFORMANCE_SUCCESS,
    FETCH_AGENT_PERFORMANCE_FAILURE,
    FETCH_AGENT_CUSTOMER_SATISFACTION_REQUEST,
    FETCH_AGENT_CUSTOMER_SATISFACTION_SUCCESS,
    FETCH_AGENT_CUSTOMER_SATISFACTION_FAILURE,
} from "./types";

import {
    fetchAgentAnalyticsDashboard,
    fetchAgentProgrammeStatistics,
    fetchAgentCertificationStatistics,
    fetchAgentOperationalStatistics,
    fetchTopPerformingAgents,
    fetchAgentPerformance,
    fetchAgentCustomerSatisfaction,
} from "../../services/agentAnalyticsService";


export const fetchAgentAnalyticsDashboardRequest = () => ({
    type: FETCH_AGENT_ANALYTICS_DASHBOARD_REQUEST,
});

export const fetchAgentAnalyticsDashboardSuccess = (
    data
) => ({
    type: FETCH_AGENT_ANALYTICS_DASHBOARD_SUCCESS,
    payload: data,
});

export const fetchAgentAnalyticsDashboardFailure = (
    error
) => ({
    type: FETCH_AGENT_ANALYTICS_DASHBOARD_FAILURE,
    payload: error,
});


export const fetchAgentProgrammeRequest = () => ({
    type: FETCH_AGENT_PROGRAMME_REQUEST,
});

export const fetchAgentProgrammeSuccess = (data) => ({
    type: FETCH_AGENT_PROGRAMME_SUCCESS,
    payload: data,
});

export const fetchAgentProgrammeFailure = (error) => ({
    type: FETCH_AGENT_PROGRAMME_FAILURE,
    payload: error,
});


export const fetchAgentCertificationRequest = () => ({
    type: FETCH_AGENT_CERTIFICATION_REQUEST,
});

export const fetchAgentCertificationSuccess = (
    data
) => ({
    type: FETCH_AGENT_CERTIFICATION_SUCCESS,
    payload: data,
});

export const fetchAgentCertificationFailure = (
    error
) => ({
    type: FETCH_AGENT_CERTIFICATION_FAILURE,
    payload: error,
});


export const fetchAgentOperationsRequest = () => ({
    type: FETCH_AGENT_OPERATIONS_REQUEST,
});

export const fetchAgentOperationsSuccess = (data) => ({
    type: FETCH_AGENT_OPERATIONS_SUCCESS,
    payload: data,
});

export const fetchAgentOperationsFailure = (error) => ({
    type: FETCH_AGENT_OPERATIONS_FAILURE,
    payload: error,
});


export const fetchTopPerformingAgentsRequest = () => ({
    type: FETCH_TOP_PERFORMING_AGENTS_REQUEST,
});

export const fetchTopPerformingAgentsSuccess = (
    data
) => ({
    type: FETCH_TOP_PERFORMING_AGENTS_SUCCESS,
    payload: data,
});

export const fetchTopPerformingAgentsFailure = (
    error
) => ({
    type: FETCH_TOP_PERFORMING_AGENTS_FAILURE,
    payload: error,
});


export const fetchAgentPerformanceRequest = () => ({
    type: FETCH_AGENT_PERFORMANCE_REQUEST,
});

export const fetchAgentPerformanceSuccess = (data) => ({
    type: FETCH_AGENT_PERFORMANCE_SUCCESS,
    payload: data,
});

export const fetchAgentPerformanceFailure = (
    error
) => ({
    type: FETCH_AGENT_PERFORMANCE_FAILURE,
    payload: error,
});


export const fetchAgentCustomerSatisfactionRequest =
    () => ({
        type:
            FETCH_AGENT_CUSTOMER_SATISFACTION_REQUEST,
    });

export const fetchAgentCustomerSatisfactionSuccess = (
    data
) => ({
    type:
        FETCH_AGENT_CUSTOMER_SATISFACTION_SUCCESS,
    payload: data,
});

export const fetchAgentCustomerSatisfactionFailure = (
    error
) => ({
    type:
        FETCH_AGENT_CUSTOMER_SATISFACTION_FAILURE,
    payload: error,
});


export const fetchAgentAnalyticsDashboardAction =
    () => async (dispatch) => {
        dispatch(
            fetchAgentAnalyticsDashboardRequest()
        );

        const response =
            await fetchAgentAnalyticsDashboard();

        if (response.success) {
            dispatch(
                fetchAgentAnalyticsDashboardSuccess(
                    response.data
                )
            );
        } else {
            dispatch(
                fetchAgentAnalyticsDashboardFailure(
                    response.error
                )
            );
        }

        return response;
    };


export const fetchAgentProgrammeAction =
    () => async (dispatch) => {
        dispatch(fetchAgentProgrammeRequest());

        const response =
            await fetchAgentProgrammeStatistics();

        if (response.success) {
            dispatch(
                fetchAgentProgrammeSuccess(
                    response.data
                )
            );
        } else {
            dispatch(
                fetchAgentProgrammeFailure(
                    response.error
                )
            );
        }

        return response;
    };


export const fetchAgentCertificationAction =
    () => async (dispatch) => {
        dispatch(
            fetchAgentCertificationRequest()
        );

        const response =
            await fetchAgentCertificationStatistics();

        if (response.success) {
            dispatch(
                fetchAgentCertificationSuccess(
                    response.data
                )
            );
        } else {
            dispatch(
                fetchAgentCertificationFailure(
                    response.error
                )
            );
        }

        return response;
    };


export const fetchAgentOperationsAction =
    () => async (dispatch) => {
        dispatch(fetchAgentOperationsRequest());

        const response =
            await fetchAgentOperationalStatistics();

        if (response.success) {
            dispatch(
                fetchAgentOperationsSuccess(
                    response.data
                )
            );
        } else {
            dispatch(
                fetchAgentOperationsFailure(
                    response.error
                )
            );
        }

        return response;
    };


export const fetchTopPerformingAgentsAction =
    (limit = 10) =>
    async (dispatch) => {
        dispatch(
            fetchTopPerformingAgentsRequest()
        );

        const response =
            await fetchTopPerformingAgents(limit);

        if (response.success) {
            dispatch(
                fetchTopPerformingAgentsSuccess(
                    response.data
                )
            );
        } else {
            dispatch(
                fetchTopPerformingAgentsFailure(
                    response.error
                )
            );
        }

        return response;
    };


export const fetchAgentPerformanceAction =
    () => async (dispatch) => {
        dispatch(fetchAgentPerformanceRequest());

        const response =
            await fetchAgentPerformance();

        if (response.success) {
            dispatch(
                fetchAgentPerformanceSuccess(
                    response.data
                )
            );
        } else {
            dispatch(
                fetchAgentPerformanceFailure(
                    response.error
                )
            );
        }

        return response;
    };


export const fetchAgentCustomerSatisfactionAction =
    () => async (dispatch) => {
        dispatch(
            fetchAgentCustomerSatisfactionRequest()
        );

        const response =
            await fetchAgentCustomerSatisfaction();

        if (response.success) {
            dispatch(
                fetchAgentCustomerSatisfactionSuccess(
                    response.data
                )
            );
        } else {
            dispatch(
                fetchAgentCustomerSatisfactionFailure(
                    response.error
                )
            );
        }

        return response;
    };